import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { fetchUserData, logout } from "../../../services/authServicepa";

const UserProfileLogoutIcon = ({ className = "", showRole = true }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadUser = async () => {
      const data = await fetchUserData();
      setUser(data);
    };
    loadUser();
  }, []);

  if (!user) return null;

  return (
    <div
      className={`user-profile-icon ${className}`}
      style={{ display: "flex", alignItems: "center", gap: "10px" }}
    >
      {showRole && (
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 600 }}>
            {user.emp_name || "User"}
          </div>
          <div style={{ fontSize: 12, color: "#555" }}>
            {user.role || "Employee"}
          </div>
        </div>
      )}

      <LogOut
        size={20}
        style={{ cursor: "pointer", color: "#e53935" }}
        onClick={() => logout(navigate)}
        title="Logout"
      />
    </div>
  );
};

export default UserProfileLogoutIcon;
